import type { IconData } from '@stacksjs/iconify-core'

export const controlButtonsRewind: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m0 8l10-8v4.8L16 0v16l-6-4.8V16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default controlButtonsRewind
